<template lang="pug">
  v-container
    v-row
      v-col
        v-list
          v-list-item(@click="$createOnClick({ onClickDark: () => themeDark = !themeDark })")
            v-list-item-content Thème sombre
            v-list-item-action
              v-switch(
                v-model="themeDark"
                @click.stop=""
                color="primary")
          v-list-item(@click="$createOnClick({ onClickLanguage: workInProgress })")
            v-list-item-content Langue
            v-list-item-icon
              v-icon {{ mdiChevronRight }}
          v-list-item(@click="$createOnClick({ onClickNotifications: workInProgress })")
            v-list-item-content Notifications
            v-list-item-icon
              v-icon {{ mdiChevronRight }}
          v-list-item(@click="$createOnClick({ onClickSecurity: workInProgress })")
            v-list-item-content Sécurité
            v-list-item-icon
              v-icon {{ mdiChevronRight }}
          v-list-item(@click="$createOnClick({ goToTermsOfServices })")
            v-list-item-content Conditions Générales d'Utilisation
            v-list-item-icon
              v-icon {{ mdiChevronRight }}
          v-list-item(@click="$createOnClick({ onClickSuppressAccount: workInProgress })")
            v-list-item-content Supprimer le compte
            v-list-item-icon
              v-icon {{ mdiChevronRight }}
</template>

<script>
import { page, theme } from '@iez/core'
import { mdiChevronRight } from '@mdi/js'
import { computed } from '@vue/composition-api'

const route = {
  path: `/settings`,
  name: `Settings`
}

export default {
  ...route,

  setup () {
    page.topBar.set({
      title: `Paramètres`
    })

    const themeDark = computed({
      get: () => theme.dark,
      set: value => {
        theme.dark = value
      }
    })

    const goToTermsOfServices = () => {
      const url = `https://yako.co/conditions-generales-utilisation/`
      open(url, `_blank`).focus()
    }

    const workInProgress = () => {
      page.blockingDialog.set({
        title: `Essayez ultérieurement`,
        content: `Cette fonctionnalité n'est pas disponible pour le moment.`,
        action1: {
          label: `Fermer`,
          onClick: () => {
            page.blockingDialog.unset()
          }
        }
      })
    }

    return {
      mdiChevronRight,
      themeDark,
      goToTermsOfServices,
      workInProgress
    }
  }
}
</script>